<div class="row form-group">
  <label class="control-label col-4">{{'Khóa/Mở tài khoản' | translate}}</label>
  <div class="col-8 required-field">
    <ng-select #slTrangThai
               class="twcollong"
               [tabIndex]="3"
               [openOnEnter]="false"
               [items]="inputtrangthais"
               bindValue="Id"
               bindLabel="Ten"
               notFoundText="Không có dữ liệu"
               [searchFn]="comboSearchFn2"
               [(ngModel)]="doituongSelect.TrangThai">
      <ng-template ng-option-tmp let-item="item">

        <div class="rTableRow">
          <div class="rTableCell">{{item.Ten}}</div>
        </div>
      </ng-template>
    </ng-select>
  </div>
</div>

<div class="row form-group">
  
</div>

<div class="modal-footer" style="display: flex;justify-content: space-between;">
  <div style="display:flex;">
    <!--<div class="checkbox c-checkbox"> password
    <label>
      <input tabIndex="20" type="checkbox" [(ngModel)]="doituongSelect.TrangThaiXuLy" />
      <span class="fa fa-check"></span> Đã xử lý xong
    </label>
  </div>-->
  </div>
  <div class="">
    <button class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="Ấn ESC để thoát" style="padding-top:0px !important">Hủy bỏ</button>
    <button  type="submit" (click)="DoiMatKhau()" title="Ấn F9 để lưu" class="mb-1 mr-1 btn btn-primary" style="padding-top:0px !important">Lưu lại</button>
  </div>

</div>


